/* ================================================================
   JS propio de la tienda — todo vanilla, sin librerias.
   Un init por componente; cada uno comprueba si su elemento existe.
   ================================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- Reveals al hacer scroll ----
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mt-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // ---- Contadores animados (count-up) ----
  function initContadores() {
    var nums = document.querySelectorAll('[data-mt-count]');
    if (!nums.length) return;
    function animate(el) {
      var target = parseFloat(el.getAttribute('data-mt-count'));
      var decimals = (el.getAttribute('data-mt-decimals')) ? parseInt(el.getAttribute('data-mt-decimals'), 10) : 0;
      var prefix = el.getAttribute('data-mt-prefix') || '';
      var suffix = el.getAttribute('data-mt-suffix') || '';
      if (reduce) { el.textContent = prefix + target.toLocaleString('es-CO', {minimumFractionDigits: decimals, maximumFractionDigits: decimals}) + suffix; return; }
      var start = null, dur = 1600;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var val = target * eased;
        el.textContent = prefix + val.toLocaleString('es-CO', {minimumFractionDigits: decimals, maximumFractionDigits: decimals}) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = prefix + target.toLocaleString('es-CO', {minimumFractionDigits: decimals, maximumFractionDigits: decimals}) + suffix;
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(animate); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animate(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  // ---- Acordeon (FAQ) ----
  function initAcordeon() {
    var items = document.querySelectorAll('[data-mt-acc]');
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector('[data-mt-acc-btn]');
      var panel = item.querySelector('[data-mt-acc-panel]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        item.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
        panel.style.maxHeight = open ? null : (panel.scrollHeight + 'px');
      });
    });
  }

  // ---- Contador de oferta (se reinicia cada día, honesto) ----
  function initCountdowns() {
    var els = document.querySelectorAll('[data-mt-countdown]');
    if (!els.length) return;
    function tick() {
      var now = new Date();
      var end = new Date();
      end.setHours(23, 59, 59, 999);
      var diff = Math.max(0, end - now);
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var txt = pad(h) + ':' + pad(m) + ':' + pad(s);
      els.forEach(function (el) {
        var t = el.querySelector('[data-mt-cd-time]') || el;
        t.textContent = txt;
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  // ---- Fecha de entrega estimada ----
  function initEntrega() {
    var els = document.querySelectorAll('[data-mt-entrega]');
    if (!els.length) return;
    var meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    var dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    els.forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min') || '2', 10);
      var max = parseInt(el.getAttribute('data-max') || '5', 10);
      var now = new Date();
      var d1 = new Date(now); d1.setDate(now.getDate() + min);
      var d2 = new Date(now); d2.setDate(now.getDate() + max);
      var out = el.querySelector('[data-mt-entrega-fechas]');
      if (!out) return;
      var txt;
      if (d1.getMonth() === d2.getMonth()) {
        txt = 'el ' + d1.getDate() + ' y el ' + d2.getDate() + ' de ' + meses[d2.getMonth()];
      } else {
        txt = 'el ' + d1.getDate() + ' de ' + meses[d1.getMonth()] + ' y el ' + d2.getDate() + ' de ' + meses[d2.getMonth()];
      }
      out.textContent = txt;
    });
  }

  // ---- Galeria de producto ----
  function initGaleria() {
    var gal = document.querySelector('[data-mt-gallery]');
    if (!gal) return;
    var main = gal.querySelector('[data-mt-main]');
    var thumbs = gal.querySelectorAll('[data-mt-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (src) main.src = src;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  // ---- Variantes de producto ----
  function initVariantes() {
    var root = document.querySelector('[data-mt-variants]');
    var dataEl = document.querySelector('[data-mt-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = root ? root.querySelectorAll('select[data-mt-option]') : [];
    var idInput = document.querySelector('[data-mt-variant-id]');
    var priceEl = document.querySelector('[data-mt-price]');
    var btn = document.querySelector('[data-mt-addbtn]');
    var soldText = btn ? btn.getAttribute('data-sold-text') : 'Agotado';
    var buyText = btn ? btn.getAttribute('data-buy-text') : 'Comprar';

    function money(cents) {
      var v = (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return '$' + v;
    }
    function update() {
      if (!selects.length) return;
      var chosen = [];
      selects.forEach(function (s) { chosen.push(s.value); });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (btn) {
        if (match.available) { btn.disabled = false; btn.textContent = buyText; }
        else { btn.disabled = true; btn.textContent = soldText; }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  // ---- Barra de compra fija en movil ----
  function initStickyBuy() {
    var bar = document.querySelector('[data-mt-stickybuy]');
    var anchor = document.querySelector('[data-mt-buyanchor]');
    if (!bar || !anchor) return;
    var barBtn = bar.querySelector('[data-mt-sticky-add]');
    var realForm = document.querySelector('.mt-prod__form');
    if (barBtn && realForm) {
      barBtn.addEventListener('click', function () {
        var submit = realForm.querySelector('[data-mt-addbtn]');
        if (submit && !submit.disabled) { realForm.requestSubmit ? realForm.requestSubmit(submit) : submit.click(); }
      });
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // Mostrar la barra cuando el boton real NO esta a la vista
        bar.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  function boot() {
    initReveals();
    initContadores();
    initCountdowns();
    initEntrega();
    initAcordeon();
    initGaleria();
    initVariantes();
    initStickyBuy();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
